import Link from 'next/link';
import { ArrowRight } from '@/components/pages/icons';
import type { NavLink } from './type';

export function MobileSubmenuLink({ label, href }: NavLink) {
  return (
    <li className="text-[32px] leading-[120%] tracking-[-0.96px] px-4 py-6">
      <Link href={href || '#'} className="flex items-center justify-between">
        <span>{label}</span>
        {/*<ArrowRight className="w-6 h-6 text-brand-accent" />*/}
      </Link>
    </li>
  );
}
